/*
 * File: huddle.service.ts
 * Project: a-a
 * File Created: Thursday, 27th March 2025 8:44:12 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 27th March 2025 8:48:06 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import axios from '../core/axios';

import { ApiConstants } from './api-constants';

export class HuddleService {
  static saveProfile = async (email: string, data: any) => {
    return await (
      await axios.post(ApiConstants.HUDDLE_API.SAVE_PROFILE.URL(email), data)
    ).data;
  };
}
